import { ProductDtoAttributes } from "./Product"

export function getStore(state): ProductDtoAttributes {
    return state.product
}

export function getMatrixAttributes(state)  {
    return getStore(state).matrix.attributes
}

export function getActiveMatrixAxes(state) {
    return getStore(state).matrix.attributes.axes?.filter(item => {
        return item.name !== "" && item.options?.length > 0
    }) || []
}

export function getActiveMatrixItems(state)  {
    return getStore(state).matrix.attributes.items.filter(item => !item.attributes.deleted)
}

export function getDeletedMatrixItems(state) {
    return getStore(state).matrix.attributes.items.filter(item => item.attributes.deleted)
}

export function getMatrixItemsLength(state)  {
    return getStore(state).matrix.attributes.items.filter(item => !item.attributes.deleted).length
}

export function getBundleItems(state) {
    return getStore(state).bundle?.attributes.bundleProducts || []
}



// WEBPACK FOOTER //
// ./src/state/product/ProductSelectors.ts